import CasesGrid from "./sections/CasesGrid";
import PageHeader from "../components/PageHeader/PageHeader";

function UseCases() {
  return (
    <>
      <PageHeader eyebrow="Casos de uso" title="Así se usa EcoRep en la práctica" />
      <CasesGrid />
    </>
  );
}

export default UseCases;
